<template>
  <div>
    <v-modal-contents ref="modal_contents_agree">

      <template v-slot:close>
        <!--        убираем close-->
        <div></div>
      </template>

      <template v-slot:title>

        <div class="terms_of_use__title">
          <div class="h2_title">Условия использования персональных данных</div>
        </div>
      </template>
      <template v-slot:content>
        <div class="terms_of_use mt-30 ">
          <div v-html="terms"></div>
          <div class="mt-30">
            <button class="px-30 btn-red "
                    @click="$refs.modal_contents_agree.modal_open()">
              Прочитал
            </button>

          </div>
        </div>
      </template>
    </v-modal-contents>

    <v-form ref="form" class="tapes-order-form" action="#" @submit.prevent="" id="formNew" v-model="valid"
            lazy-validation>
      <div class="row mx-0 my-0">
        <slot name="description">
          <div class="col-12 col-md-6 col-lg-6 p-md-2">
          </div>
        </slot>

        <div class="col-12 col-md-6 col-lg  p-0">
          <div class="row mx-0 my-0">
            <div class="col-12 ">
              <div class="tapes-order-form__item">
                <v-text-field
                    v-model="name"
                    :rules="[rules.required, rules.name]"
                    required=""
                    class="tapes-order-form__input"
                    id="name"
                >
                  <template v-slot:label>
                    ФИО *
                  </template>
                </v-text-field>
              </div>
            </div>
          </div>

          <div class="row mx-0 my-0">
            <div class="col-12 col-md-6 ">
              <div class="tapes-order-form__item position-relative">
                <v-text-field
                    v-model="tel"
                    id="tel"
                    oninput="this.value = this.value.replace(/^\(8/, '(');"
                    required
                    :rules="[rules.required]"
                    class="tapes-order-form__input"
                    max="20"
                    v-mask="'# ### ###-##-##'"
                >
                  <template v-slot:label>
                    Телефон *
                  </template>
                </v-text-field>
              </div>
            </div>

            <div class="col-12 col-md-6 ">
              <div class="tapes-order-form__item">
                <v-text-field class="tapes-order-form__input"
                              v-model="email"
                              :rules="[rules.mail]"
                              oninput="this.value = this.value.trim()"
                              id="email"
                >
                  <template v-slot:label>
                    Электронная почта
                  </template>
                </v-text-field>

              </div>
            </div>
          </div>

          <div class="row mx-0 my-0">
            <div class="col-12  col-sm-4">
              <div class="tapes-order-form__item">
                <v-select
                    :items="width"
                    label="Ширина, мм"
                    v-model="selectedWidth"
                    append-icon="mdi mdi-chevron-down"
                    id="width"
                    class="tapes-order-form__input"
                    :menu-props="{ contentClass: 'wrapp_cooperation' }"
                >

                </v-select>
              </div>
            </div>
            <div class="col-12  col-sm-4">
              <div class="tapes-order-form__item">
                <v-select
                    :items="length"
                    label="Длина, м"
                    v-model="selectedLength"
                    required=""
                    append-icon="mdi mdi-chevron-down"
                    id="height"
                    class="tapes-order-form__input"
                    :menu-props="{ contentClass: 'wrapp_cooperation' }"
                >
                </v-select>
              </div>
            </div>
            <div class="col-12  col-sm-4">
              <div class="tapes-order-form__item">
                <v-select
                    :items="thickness"
                    label="Толщина, мкм"
                    v-model="selectedThickness"
                    required=""
                    append-icon="mdi mdi-chevron-down"
                    id="thickness"
                    class="tapes-order-form__input"
                    :menu-props="{ contentClass: 'wrapp_cooperation' }"
                >
                </v-select>
              </div>
            </div>
          </div>

          <div class="row mx-0 my-0">
            <div class="col-12  col-sm-4">
              <div class="tapes-order-form__item">
                <v-select
                    :items="color"
                    label="Цвет фона"
                    v-model="selectedColor"
                    append-icon="mdi mdi-chevron-down"
                    id="color"
                    class="tapes-order-form__input"
                    :menu-props="{ contentClass: 'wrapp_cooperation' }"
                >
                </v-select>
              </div>
            </div>
            <div class="col-12  col-sm-4">
              <div class="tapes-order-form__item">
                <v-select
                    :items="colorAmount"
                    label="Кол-во цветов печати"
                    v-model="selectedColorAmount"
                    append-icon="mdi mdi-chevron-down"
                    id="colorAmount"
                    class="tapes-order-form__input"
                    :menu-props="{ contentClass: 'wrapp_cooperation' }"
                >
                </v-select>
              </div>
            </div>
            <div class="col-12  col-sm-4">
              <div class="tapes-order-form__item">
                <v-text-field
                    v-model="printing"
                    class="tapes-order-form__input"
                    id="printing"
                >
                  <template v-slot:label>
                    Тираж, рулонов

                  </template>
                </v-text-field>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-12 ">
            <div class="tapes-order-form__item ">
              <div
                  class="summary p-12 bg-gray-100 border border-gray-300 drag_form d-flex flex-column justify-content-center"
                  @dragover="dragover"
                  @dragleave="dragleave"
                  @drop="drop"
                  id="summary"
              >
                <input
                    type="file"
                    multiple
                    name="fields[assetsFieldHandle][]"
                    id="assetsFieldHandle"
                    class="w-px h-px opacity-0 overflow-hidden absolute"
                    @change="onChange"
                    ref="file"
                    accept=".pdf,.jpg,.jpeg,.png,.rtf,.doc,.docx,.xls,.xlsx"
                />

                <label for="assetsFieldHandle" class="block cursor-pointer">
                  <div>
                    Загрузить макет (Перетащите файлы сюда или нажмите, чтобы загрузить)
                  </div>
                </label>
                <ul class="mt-4" v-if="this.filelist.length" v-cloak>
                  <li class="text-sm p-1 text-left" v-for="(file, index) in filelist" :key="index">
                    {{ file.name }}
                    <button
                        class="ml-2 remove_file"
                        type="button"
                        @click="remove(filelist.indexOf(file))"
                        title="Remove file"
                    >
                      Удалить
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-12 pb-3 px-3 pt-3">
            <!-- SmartCaptcha -->
            <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'"
                 class="w-100 mt-30"></div>
            <div class="mt-30">
              <v-checkbox
                  v-model="checkbox"
                  :rules="[(v) => !!v || 'Это обязательный пункт']"
                  required
                  color="red"
              >
                <template v-slot:label>
                  <div class="customLabelForm">
                    Я выражаю согласие с <a href="javascript:void(0);" target="_blank"
                                            @click="$refs.modal_contents_agree.modal_open('scroll_false')">условиями
                    использования</a> моих персональных данных для обработки данного обращения ООО
                    «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г.
                    Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю
                    согласие с
                    <a :href="policy" @click="linkOpen(policy)" class="position-relative zi-1">Политикой
                      конфиденциальности</a> и <a :href="agreement" @click="linkOpen(agreement)"
                                                  class="position-relative zi-1">Пользовательским
                    соглашением.</a>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox
                  v-model="consentToInform"

                  color="red"
                  class="mt-0"
              >
                <template v-slot:label>
                  <div class="customLabelForm">
                    Я выражаю согласие на информирование меня о продуктах, акциях, выгодных
                    предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206,
                    Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и
                    партнеров.
                  </div>
                </template>
              </v-checkbox>

              <div class="btn_form teeestt  d-flex align-items-center justify-content-start ">
                <v-btn :disabled="!valid" class=" btn-red w-mc" type="submit"
                       @click="sendForm">
                  Отправить
                </v-btn>
              </div>
            </div>

          </div>

        </div>
      </div>

    </v-form>
  </div>

</template>

<script>
import VModalContents from "./modal_contents";
import {mask} from 'vue-the-mask';

export default {
  components: {
    VModalContents: VModalContents,
  },
  directives: {mask},
  name: "formOrderTapes",
  props: {
    directions: Array | String | Number | Boolean | Object,
    policy: String | Boolean,
    agreement: String | Boolean,
    terms: String | Boolean,
    width: Array | Object | String | Number | Boolean,
    length: Array | Object | String | Number | Boolean,
    thickness: Array | Object | String | Number | Boolean,
    background: Array | Object | String | Number | Boolean,
    amount: Array | Object | String | Number | Boolean,
  },
  data() {
    return {
      captchaPassed: false,
      valid: true,

      rules: {
        required: value => !!value || 'Обязательное поле',
        name: value => {
          const patternSp = /[~`!@№#$%^&*()+={}\[\];:\'\"<>.,]|[0-9_]/g
          return !patternSp.test(value) || 'Неккоректный ввод'
        },
        mail: value => {
          if (!value) return true;
          const pattern = /^(([^<>()[\]\\{\/№%^!#/$?*~+=.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Неккоректная электронная почта'
        },

        phone: value => {
          const pattern = /^\+?[1-9][0-9]{7,14}$/
          return pattern.test(value) || 'Некорректный телефон'
        }
      },

      name: "",
      email: "",
      tel: "",
      /*width: [
          {name: "100", id: "123"},
          {name: "200", id: "321"}
      ],*/
      selectedWidth: null,
      /*height: [
          {name: "200", id: "13"},
          {name: "300", id: "32"}
      ],*/
      selectedLength: null,
      /*thickness: [
          {name: "10", id: "173"},
          {name: "30", id: "352"}
      ],*/
      selectedThickness: null,

      /*color: [
          {name: "белый", id: "73"},
          {name: "красный", id: "52"}
      ],*/
      color: this.background,
      selectedColor: null,

      /*colorAmount: [
          {name: "2", id: "83"},
          {name: "3", id: "92"}
      ],*/
      colorAmount: this.amount,
      selectedColorAmount: null,

      printing: '',

      checkbox: false,
      consentToInform: false,

      // upload drag-and-drop file
      filelist: [],
    };
  },

  methods: {

    linkOpen(url) {
      window.open(url, '_blank');
    },

    // Captcha
    initCaptcha() {
      window.smartCaptcha.render('captcha-container', {
        sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
        callback: this.onCaptchaSuccess,
      });
    },
    onCaptchaSuccess(token) {
      this.captchaPassed = true;
      this.form.captchaToken = token;
    },
    // Captcha end

    sendForm() {
      if (!this.$refs.form.validate()) return false;
      if (!this.captchaPassed) {
        this.valid = false;
        return false;
      } else {
        this.valid = true;
      }
      /** AJAX */
      var VueObject = this;
      var formData = new FormData();
      $.each(VueObject.filelist, function (key, value) {
        formData.append(key, value);
      });


      formData.append("name", VueObject.name);
      formData.append("phone", VueObject.tel);
      formData.append("email", VueObject.email);
      formData.append("selectedWidth", VueObject.selectedWidth);
      formData.append("selectedLength", VueObject.selectedLength);
      formData.append("selectedThickness", VueObject.selectedThickness);
      formData.append("selectedColor", VueObject.selectedColor);
      formData.append("selectedColorAmount", VueObject.selectedColorAmount);
      formData.append("printing", VueObject.printing);
      formData.append("ajaxPost", "Y");
      console.log("форма form_order_tapes", formData);
      
      let requestSuccess = false;
      $.ajax({
        "type": "POST",
        // "url": "/ajax/cooperation_form.php",
        "url": "/ajax/printed_form.php",
        "data": formData,
        "cache": false,
        "dataType": 'json',
        "processData": false, // Не обрабатываем файлы (Don't process the files)
        "contentType": false, // Так jQuery скажет серверу, что это строковой запрос
        "success": function (res) {
          if (res.RESULT == "success") {
            requestSuccess = true;
            console.log(res);
            $(".text_result").slideDown(300);
            $(".text_result").delay(3000).slideUp(300);
            VueObject.$refs.form.reset();
          }
          // setTimeout(function () {
          //     window.location.reload()
          // }, 3000);
        },
        error: function (xhr, ajaxOptions, thrownError) {
          console.log("ERROR:", xhr.status);
          console.log("RESPONSE:", xhr.responseText);
        },
        complete: function (xhr, status) {
          // Все случаи, когда success НЕ произошёл
          if (!requestSuccess) {
            $.ajax({
              type: "POST",
              url: "/ajax/log_form.php",
              data: {
                form: "form_order_tapes",

                ajax_status: status,

                http_status: xhr.status,
                status_text: xhr.statusText,

                response: xhr.responseText || "",

                name: VueObject.name,
                phone: VueObject.tel,
                email: VueObject.email,

                selectedWidth: VueObject.selectedWidth,
                selectedLength: VueObject.selectedLength,
                selectedThickness: VueObject.selectedThickness,
                selectedColor: VueObject.selectedColor,
                selectedColorAmount: VueObject.selectedColorAmount,
                printing: VueObject.printing,
                ajaxPost: "Y",
              }
            });
            $(".text_result_err").slideDown(300);
            $(".text_result_err").delay(3000).slideUp(300);
          }
        },

      });
    },


    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },

    // upload drag-and-drop file

    onChange() {
      this.filelist = [...this.$refs.file.files];
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },

    // upload drag-and-drop file end
  },
  created() {
    setTimeout(() => {
      this.initCaptcha();
    }, 500)
  },
  watch: {
    captchaPassed() {
      // this.sendForm();
      if (!this.captchaPassed) {
        this.valid = false;
        return false;
      } else {
        this.valid = true;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.tapes-order-form {
  box-sizing: border-box;
  border: 1px solid #f2f2f2;
  border-radius: 30px;
  background: #F5F5F7;
  padding: 20px 20px;

  @media (max-width: 425px) {
    padding: 10px;
  }

  &__item {

  }

  &__input {
    width: auto;
    border: 1px solid #E2E2E2;
    border-radius: 6px;
    padding: 25px 15px !important;
    margin: 0 !important;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: #282828;
    resize: none;
    background: #FFFFFF;
    max-height: 80px;
  }

  .smart-captcha {
    min-width: 220px;
  }

  .smart-captcha.error-captcha:before {
    color: #FA4237;
    transform: translateY(-8px);
    background: transparent;
  }

  .drag_form {
    background: rgba(249, 66, 55, 0.06);
    border: 1px dashed #f94237 !important;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: "RobotoRegular";
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    display: flex;
    align-items: center;
    opacity: 0.7;
    text-align: center;

    & label {
      font-family: "RobotoRegular";
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 120%;
      align-items: center;
      color: #FA4237;
      opacity: 0.7;
      width: 100%;
      margin: auto;
      height: 100%;
      padding: 40px 21px;
      justify-content: center;
    }
  }

  .customLabelForm {
    & a {
      text-decoration: underline transparent;
      transition: all 0.2s ease;

      &:hover {
        text-decoration: underline #FA4237;
      }
    }
  }
}
</style>

<style lang="scss">
.tapes-order-form {

  &__title {
    font-family: "MuseoSansCyrl-500";
    font-weight: 400;
    font-style: 500;
    font-size: 52px;
    leading-trim: NONE;
    line-height: 68px;
    letter-spacing: -1.04px;
    vertical-align: middle;

    @media (max-width: 1000px) {
      font-size: 46px;
      line-height: 56px;
    }

    @media (max-width: 650px) {
      font-size: 38px;
      line-height: 44px;
    }

    @media (max-width: 500px) {
      font-size: 30px;
      line-height: 36px;
    }

  }


  & .tapes-order-form__item .primary--text {
    color: #656565 !important;
    caret-color: #656565 !important;
  }

  & .v-select.v-text-field:not(.v-text-field--single-line) input {
    display: none;
  }

  & .v-select__selections {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }

  & .v-text-field__details {
    position: absolute;
    display: flex;
    transform: translate(-1px, 38px);
  }

  & .v-input__slot {
    margin: 0 !important;

    &::before {
      display: none !important;
    }

    &::after {
      display: none !important;
    }
  }

  .v-text-field .v-label {
    background: #ffffff;
    height: 22px;
    width: 100%;
    color: #404040;
  }

  .v-btn:not(.v-btn--round).v-size--default {
    height: unset;
  }

  .v-text-field .v-label {
    background: #ffffff;
    height: 22px;
    width: 100%;
    color: #404040;
  }

  .v-application .error--text {
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
  }

  .v-list-item {
    @media (max-width: 766px) {
      margin-bottom: 10px;
    }
  }

  .v-application .v-input--is-focused {
    border-color: #4F4D55;
  }

  .v-application .error--text {
    border-color: #ff5252 !important;
  }

}
</style>